import React, { useState } from 'react';
import akarFile from 'assets/img/akar-file.svg';
import { Button } from 'react-bootstrap';
import SaveModalKanban from './SaveModalKanban';
import SaveTemplate from './SaveTemplate';
import { useSocket } from 'pages/projects/kanban/context/SocketContext';

const EmptyBoardState = ({ boardId, setBoards, setShowEmptyBoardState, onCreateWithTemplate, canEditBoard = false }) => {
  const socket = useSocket();
  const [creationOptionsOpen, setCreationOptionsOpen] = useState(false);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [boardTitle, setBoardTitle] = useState('');

  const handleEditBoard = async (title) => {
    if (!canEditBoard) return;
    console.log(title, 'title');

    console.log(boardId, 'boardIds');

    try {
      setIsSaving(true);
      socket.emit('update-project-board', {
        id: boardId,
        payload: { name: title }
      });

      setBoards((prevState) =>
        prevState.map((state) => {
          if (state._id === boardId) {
            return { ...state, name: title };
          }
          return state;
        })
      );
      setShowEmptyBoardState(false);
      setSaveModalOpen(false);
      setBoardTitle('');
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <section className="blank-sec dashboard-sec">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-12">
            <div className="blankList-box-cover">
              <div className="blankList-box">
                <img className="akarFile" src={akarFile} />
                <h2>You have no boards at the moment.</h2>
                <p>
                  {canEditBoard
                    ? 'Click the + button below to create a new board and start organizing your tasks and ideas.'
                    : 'You have view-only access to this board.'}
                </p>
                {/* {hasPermission(userRole, 'update_projects') && <p>{ProjectListStrings.noProjectsDescription}</p>} */}
                {canEditBoard && <Button
                  icon={'fas fa-plus'}
                  // rotate={true}
                  styles={{ backgroundColor: 'blue', color: 'white' }}
                  onClick={() => setCreationOptionsOpen(true)}
                  className={`add-btn-empty `}>
                  <i className="fas fa-plus"></i>
                </Button>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SaveTemplate
        show={creationOptionsOpen}
        onHide={() => setCreationOptionsOpen(false)}
        onCreateNewBoard={() => {
          setCreationOptionsOpen(false);
          setSaveModalOpen(true);
        }}
        onUseSavedTemplate={() => {
          setCreationOptionsOpen(false);
          onCreateWithTemplate();
        }}
      />
      <SaveModalKanban
        show={saveModalOpen}
        onHide={() => {
          setSaveModalOpen(false);
        }}
        isCreateBoard={true}
        isEditingBoard={false}
        title={boardTitle}
        onTitleChange={setBoardTitle}
        isLoading={isSaving}
        onSave={(title) => handleEditBoard(title)}
      />
    </section>
  );
};

export default EmptyBoardState;
